import { renderEscort } from './callRender.jsx';

renderEscort();  // сопровождение

export { renderEscort };
